import React, { useEffect, useState, useMemo } from "react";
import { resolveTheaterImageSrc } from "../utils/theaterHeroSlides";

/**
 * Hero card media: cycles images from theater folders; falls back to video when no slides.
 */
export default function HeroTheaterSlideshow({
  slides,
  fallbackVideoUrl,
  intervalMs = 5500,
}) {
  const validSlides = useMemo(
    () =>
      Array.isArray(slides)
        ? slides.filter((s) => s && resolveTheaterImageSrc(s.src))
        : [],
    [slides]
  );
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [validSlides.length]);

  useEffect(() => {
    if (validSlides.length <= 1) return undefined;
    const t = window.setInterval(() => {
      setIndex((i) => (i + 1) % validSlides.length);
    }, intervalMs);
    return () => window.clearInterval(t);
  }, [validSlides.length, intervalMs]);

  if (validSlides.length === 0) {
    if (!fallbackVideoUrl) {
      return (
        <div
          className="absolute inset-0 bg-gradient-to-br from-purple-950/90 to-black"
          aria-hidden
        />
      );
    }
    return (
      <video
        className="absolute inset-0 h-full w-full object-cover"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={fallbackVideoUrl} />
      </video>
    );
  }

  return (
    <>
      {validSlides.map((slide, i) => (
        <img
          key={`${slide.theaterFolder}-${String(resolveTheaterImageSrc(slide.src))}-${i}`}
          src={resolveTheaterImageSrc(slide.src)}
          alt=""
          aria-hidden={i !== index}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[900ms] ease-out ${
            i === index ? "z-[1] opacity-100" : "z-0 opacity-0"
          }`}
        />
      ))}
    </>
  );
}
